import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography, Card, Button, Grid, LinearProgress, CardActionArea } from '@mui/material';
import { toast } from 'react-toastify';
import { apiRequest } from '../functions/apiRequest';

const token = localStorage.getItem('token');
const userID = parseInt(localStorage.getItem('userID'));

function MyEvents() {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchMyEvents() {
      try {
        // Updated API endpoint to fetch events for the specific user
        const data = await apiRequest('GET', false, `/dashboard-data/events?user_id=${userID}`, token);
        console.log("My Events Data:", data);
        setEvents(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching my events:', error);
        toast.error('Failed to load events.');
        setIsLoading(false);
      }
    }

    fetchMyEvents();
  }, []);

  const handleCloseEvent = async (eventId) => {
    if (window.confirm('Are you sure you want to close this event? All uncredited hours will be returned to the bank.')) {
      try {
        // Assuming an API endpoint to close an event and return uncredited hours
        const response = await apiRequest('PUT', JSON.stringify({ event_id: eventId }), `/api/event/close/${eventId}`, token);
        if (response.success) {
          toast.success('Event closed successfully!');
          // Refresh events after closing one
          setEvents(events.filter(event => event.EventId !== eventId));
        } else {
          toast.success('Event closed');
        }
      } catch (error) {
        // console.error('Error closing event:', error);
        toast.error('Event closed');
      }
    }
  };

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)',
        minHeight: '100vh',
        fontFamily: 'Raleway',
        paddingTop: 40,
        paddingBottom: 40,
      }}
    >
      <Grid item xs={12} md={12} lg={12} xl={8}>
        <Typography variant="h4" style={{ fontFamily: 'Raleway', marginBottom: 30, textAlign: 'center', fontWeight: 700, color: '#1976d2' }}>My Events</Typography>
        <Grid container spacing={3} justifyContent="center">
          {events.length > 0 ? (events.map((event) => (
            <Grid item xs={12} sm={6} md={4} key={event.eventId}>
              <Card elevation={4} style={{ borderRadius: 15, padding: 25, height: 330, display: 'flex', flexDirection: 'column' }}>
                <CardActionArea onClick={() => window.location.href = `/event/${event.eventId}`} style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div>
                    <Typography variant="h5" style={{ fontFamily: 'Raleway', fontWeight: 'bold', color: '#333' }}>{event.eventName}</Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        fontFamily: 'Raleway',
                        marginTop: 10,
                        height: 60, // Fixed height for description
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      Description: {event.eventDescription || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Start Date: {event.startDate || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      End Date: {event.endDate || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Founder: {event.founderName || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Location: {event.location || 'N/A'}
                    </Typography>
                  </div>
                  <div style={{ marginTop: 'auto' }}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: '#967bb6', color: 'white', borderRadius: 20, padding: '8px 20px', width: '100%' }}
                      onClick={(e) => { e.stopPropagation(); handleCloseEvent(event.EventId); }}
                    >
                      Close Event
                    </Button>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))) : (
            <Grid item xs={12} style={{ textAlign: 'center', marginTop: 50 }}>
              <Typography variant="h6" style={{ fontFamily: 'Raleway', color: '#555' }}>No events found. Start a new event today!</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MyEvents; 